import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "oktell-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_state = _resolveComponent("page-state")!
  const _component_ok_invoice_header = _resolveComponent("ok-invoice-header")!
  const _component_ok_invoice_edit = _resolveComponent("ok-invoice-edit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_page_state, {
          key: 0,
          loading: _ctx.state.is_loading,
          "loading-message": "Загрузка данных накладной...",
          failed: _ctx.state.is_failed,
          "failed-message": "При загрузке данных накладной произошла ошибка",
          onReload: _ctx.loadInvoice
        }, null, 8, ["loading", "failed", "onReload"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ok_invoice_header, {
            invoiceNumber: _ctx.state.invoice.invoice_number,
            "is-edit": ""
          }, null, 8, ["invoiceNumber"]),
          _createVNode(_component_ok_invoice_edit, {
            class: "mt-8",
            invoice: _ctx.state.invoice,
            "updating-cargo": _ctx.state.updating_cargo,
            "invoice-id": _ctx.invoice_id,
            onSubmit: _ctx.onCargoUpdated
          }, null, 8, ["invoice", "updating-cargo", "invoice-id", "onSubmit"])
        ], 64))
  ]))
}